<template>
<div class="bouts">
    
        <div class="bout-roller">
            <p class="bout" v-for="(bout, index) in theList" :key="index">

                <span :class="{ 'winner' : bout.debaters['1'].voteCount > bout.debaters['2'].voteCount}">
                    <span class="name">{{bout.debaters['1'].name}}</span><span class="score">&nbsp;{{bout.debaters['1'].voteCount}}</span>
                </span>

                <span v-if="bout.debaters['2'].name">
                    <span class="vs">&nbsp;vs&nbsp;</span>
                    <span :class="{ 'winner' : bout.debaters['2'].voteCount > bout.debaters['1'].voteCount}">
                        <span class="score">{{bout.debaters['2'].voteCount}}&nbsp;</span><span class="name">{{bout.debaters['2'].name}}</span>
                    </span>
                </span>

            </p>
        </div>
    
    
</div>
</template>

<script>
export default {
    name: 'BoutsList',
    data() {
        return {

        }
    },
    computed: {
        theList() {
            return this.$store.state.allaPosterData.slice(0, 6)
        }
    },
}
</script>
<style lang="scss" scoped>
// @import "../scss/_variables.scss";
.bouts {
    background-color: $black;
    height: $nav-height;
    overflow:hidden;
    display: flex;
    align-items: center;
    .bout-roller {
        display: flex;
        // border: 1px solid red;
        .bout {
            // border: 1px solid orange;
            margin: 0 $icon-margin;
            white-space: nowrap;
            .name {
                color: $white;
            }
            .score {
                color: rgba(255, 255, 255, .5);
            }
            .vs {
                color: rgba(255, 255, 255, .5);
            }
            .winner {
                .name {
                    color: $white;
                }
                .score {
                    color: $icon-hover-color;
                }
            }
        }
    }
    
}
</style>
